export function numberToWords(number) {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

    if (number === 0) return 'zero';

    const chunkToWords = (chunk) => {
        let result = '';

        if (chunk >= 100) {
            result += ones[Math.floor(chunk / 100)] + ' hundred ';
            chunk %= 100;
        }

        if (chunk >= 20) {
            result += tens[Math.floor(chunk / 10)] + ' ';
            chunk %= 10;
        }

        if (chunk >= 10) {
            result += teens[chunk - 10] + ' ';
            chunk = 0;
        }

        if (chunk > 0) {
            result += ones[chunk] + ' ';
        }

        return result.trim();
    };

    let integerPart = Math.floor(number);
    const decimalPart = Math.round((number - integerPart) * 100); 
    let result = '';
    let chunkCount = 0;

    while (integerPart > 0) {
        if (integerPart % 1000 !== 0) {
            result = chunkToWords(integerPart % 1000) + ' ' + thousands[chunkCount] + ' ' + result;
        }
        integerPart = Math.floor(integerPart / 1000);
        chunkCount++;
    }

    result = result.trim();

    if (decimalPart > 0) {
        result += ` and ${chunkToWords(decimalPart)} paise`;
    }

    return result.trim();
}
